module.exports = __webpack_public_path__ + "img/Location_Minneapolis.b516a7ad.png";